// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"HeadingLevel2_subHeader__2kYCi","subHeaderUnicorn":"HeadingLevel2_subHeaderUnicorn__3XA48"};